import React from "react";
import { Button, Text, Textarea, Paper, Group } from "@mantine/core";

const Block = ({ index, runBlock, block, setBlock, results, addBlock }) => (
  <Paper shadow="md" p="xs" mb="xs" withBorder>
    <Group spacing="xs" mb="xs">
      <Button variant="gradient" compact onClick={addBlock(index)}>
        +
      </Button>
      <Button variant="gradient" compact onClick={runBlock(index)}>
        Run
      </Button>
    </Group>
    <Textarea mb="xs" autosize value={block} onChange={setBlock(index)} />
    <Text>{results[index] || "No output yet.."}</Text>
  </Paper>
);

export default Block;
